import { SxProps, Theme } from '@mui/system';

const classes = {
  formLabel: {
    color: 'primary.inputLabel',
    '&.Mui-focused': {
      color: 'primary.inputLabel',
    },
  },

  horizontal: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    '& .MuiFormLabel-root': {
      marginRight: 1,
      flex: 4,
    },
    '& .MuiFormGroup-root': {
      flex: 2,
    },
  },

  radioLabelText: {
    '& .MuiFormControlLabel-label': {
      fontSize: 14,
      color: 'common.grey850',
    },
  },
} satisfies Record<string, SxProps<Theme>>;

export default classes;
